import { render } from "./App.vue?vue&type=template&id=b9561c0e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b9561c0e&lang=css"
script.render = render

export default script